export const salesRepActionKeys = {
  DELETE_SALES_REP: 'DELETE_SALES_REP',
  FETCH_SALES_REP_CALL_GOALS: 'FETCH_SALES_REP_CALL_GOALS',
  FETCH_SALES_REPS: 'FETCH_SALES_REPS',
  REMOVE_SALES_REP: 'REMOVE_SALES_REP',
  SAVE_SALES_REP: 'SAVE_SALES_REP',
  SAVE_SALES_REP_CALL_GOALS: 'SAVE_SALES_REP_CALL_GOALS',
  SET_SALES_REP_CALL_GOALS: 'SET_SALES_REP_CALL_GOALS',
  SET_SALES_REPS: 'SET_SALES_REPS'
} as const;
